module.exports = __webpack_public_path__ + "static/media/Wounds.a1141928.svg";